// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror {
  /* Image Block */
  figure[data-type="imageBlock"] {
    margin: 0;
  }

  figure[data-type="imageBlock"] img {
    border-radius: 0.25rem; /* Rounded */
    display: block; /* Block */
    width: 100%; /* W-full */
  }

  /* Block Quote */
  figure[data-type="blockquoteFigure"] {
    margin-top: 3.5rem; /* my-14 */
    margin-bottom: 3.5rem; /* my-14 */
    color: #000000; /* Text-black */
  }

  figure[data-type="blockquoteFigure"].dark {
    color: #ffffff; /* Dark:text-white */
  }

  & > blockquote,
  [data-type="blockquoteFigure"] blockquote {
    margin: 0; /* M-0 */
  }

  [data-type="blockquoteFigure"] blockquote > *:first-child {
    margin-top: 0; /* First:mt-0 */
  }

  [data-type="blockquoteFigure"] blockquote > *:last-child {
    margin-bottom: 0; /* Last:mb-0 */
  }

  /* Columns */
  [data-type="columns"] {
    display: grid; /* Grid */
    gap: 1rem; /* Gap-4 */
    margin-top: 3.5rem; /* Mt-14 */
    margin-bottom: 3rem; /* Mb-12 */
  }

  [data-type="columns"].layout-sidebar-left {
    grid-template-columns: 40fr 60fr;
  }

  [data-type="columns"].layout-sidebar-right {
    grid-template-columns: 60fr 40fr;
  }

  [data-type="columns"].layout-two-column {
    grid-template-columns: 1fr 1fr;
  }

  [data-type="column"] {
    overflow: auto; /* Overflow-auto */
  }

  /* Details */
  [data-type="details"] {
    display: flex; /* Flex */
    gap: 0.25rem; /* Gap-1 */
    margin-top: 1.5rem; /* My-6 */
    margin-bottom: 1.5rem; /* My-6 */
    margin-left: auto; /* Mx-auto */
    margin-right: auto; /* Mx-auto */
    padding: 0.5rem; /* P-2 */
    border: 1px solid #d1d5db; /* Border-gray-300 */
    border-radius: 0.25rem; /* Rounded */
  }

  [data-type="details"] summary {
    font-weight: bold; /* Font-bold */
    display: block; /* Block */
  }

  [data-type="details"] > button {
    background-color: transparent; /* Bg-transparent */
    border: none; /* Border-none */
    cursor: pointer; /* Cursor-pointer */
    display: flex; /* Flex */
    align-items: center; /* Items-center */
    justify-content: center; /* Justify-center */
    border-radius: 0.25rem; /* Rounded */
    font-size: 0.75rem; /* Text-xs */
    height: 1.25rem; /* H-5 */
    width: 1.25rem; /* W-5 */
  }

  [data-type="details"] > button:hover {
    background-color: #d1d5db; /* Bg-gray-300 */
  }

  [data-type="details"].dark > button:hover {
    background-color: #1f2937; /* Dark:bg-gray-800 */
  }

  [data-type="details"] > button::before {
    content: "\\25B6"; /* Triangle icon */
  }

  [data-type="details"].is-open > button::before {
    transform: rotate(90deg); /* Rotate-90 */
  }

  [data-type="details"] > div {
    display: flex; /* Flex */
    flex-direction: column; /* Flex-col */
    gap: 1rem; /* Gap-4 */
    width: 100%; /* W-full */
  }

  [data-type="details"] > div > [data-type="detailsContent"] > :last-child {
    margin-bottom: 0.5rem; /* Mb-2 */
  }

  [data-type="details"] [data-type="details"] {
    margin-top: 0.5rem; /* My-2 */
    margin-bottom: 0.5rem; /* My-2 */
    margin-left: 0; /* Mx-0 */
    margin-right: 0; /* Mx-0 */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/partials/blocks.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB,EAAE,YAAY;IACpC,cAAc,EAAE,UAAU;IAC1B,WAAW,EAAE,WAAW;EAC1B;;EAEA,gBAAgB;EAChB;IACE,kBAAkB,EAAE,UAAU;IAC9B,qBAAqB,EAAE,UAAU;IACjC,cAAc,EAAE,eAAe;EACjC;;EAEA;IACE,cAAc,EAAE,oBAAoB;EACtC;;EAEA;;IAEE,SAAS,EAAE,QAAQ;EACrB;;EAEA;IACE,aAAa,EAAE,eAAe;EAChC;;EAEA;IACE,gBAAgB,EAAE,cAAc;EAClC;;EAEA,YAAY;EACZ;IACE,aAAa,EAAE,SAAS;IACxB,SAAS,EAAE,UAAU;IACrB,kBAAkB,EAAE,UAAU;IAC9B,mBAAmB,EAAE,UAAU;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc,EAAE,kBAAkB;EACpC;;EAEA,YAAY;EACZ;IACE,aAAa,EAAE,SAAS;IACxB,YAAY,EAAE,UAAU;IACxB,kBAAkB,EAAE,SAAS;IAC7B,qBAAqB,EAAE,SAAS;IAChC,iBAAiB,EAAE,YAAY;IAC/B,kBAAkB,EAAE,YAAY;IAChC,eAAe,EAAE,QAAQ;IACzB,yBAAyB,EAAE,oBAAoB;IAC/C,sBAAsB,EAAE,YAAY;EACtC;;EAEA;IACE,iBAAiB,EAAE,cAAc;IACjC,cAAc,EAAE,UAAU;EAC5B;;EAEA;IACE,6BAA6B,EAAE,mBAAmB;IAClD,YAAY,EAAE,gBAAgB;IAC9B,eAAe,EAAE,mBAAmB;IACpC,aAAa,EAAE,SAAS;IACxB,mBAAmB,EAAE,iBAAiB;IACtC,uBAAuB,EAAE,mBAAmB;IAC5C,sBAAsB,EAAE,YAAY;IACpC,kBAAkB,EAAE,YAAY;IAChC,eAAe,EAAE,QAAQ;IACzB,cAAc,EAAE,QAAQ;EAC1B;;EAEA;IACE,yBAAyB,EAAE,gBAAgB;EAC7C;;EAEA;IACE,yBAAyB,EAAE,qBAAqB;EAClD;;EAEA;IACE,gBAAgB,EAAE,kBAAkB;EACtC;;EAEA;IACE,wBAAwB,EAAE,cAAc;EAC1C;;EAEA;IACE,aAAa,EAAE,SAAS;IACxB,sBAAsB,EAAE,aAAa;IACrC,SAAS,EAAE,UAAU;IACrB,WAAW,EAAE,WAAW;EAC1B;;EAEA;IACE,qBAAqB,EAAE,SAAS;EAClC;;EAEA;IACE,kBAAkB,EAAE,SAAS;IAC7B,qBAAqB,EAAE,SAAS;IAChC,cAAc,EAAE,SAAS;IACzB,eAAe,EAAE,SAAS;EAC5B;AACF","sourcesContent":[".ProseMirror {\n  /* Image Block */\n  figure[data-type=\"imageBlock\"] {\n    margin: 0;\n  }\n\n  figure[data-type=\"imageBlock\"] img {\n    border-radius: 0.25rem; /* Rounded */\n    display: block; /* Block */\n    width: 100%; /* W-full */\n  }\n\n  /* Block Quote */\n  figure[data-type=\"blockquoteFigure\"] {\n    margin-top: 3.5rem; /* my-14 */\n    margin-bottom: 3.5rem; /* my-14 */\n    color: #000000; /* Text-black */\n  }\n\n  figure[data-type=\"blockquoteFigure\"].dark {\n    color: #ffffff; /* Dark:text-white */\n  }\n\n  & > blockquote,\n  [data-type=\"blockquoteFigure\"] blockquote {\n    margin: 0; /* M-0 */\n  }\n\n  [data-type=\"blockquoteFigure\"] blockquote > *:first-child {\n    margin-top: 0; /* First:mt-0 */\n  }\n\n  [data-type=\"blockquoteFigure\"] blockquote > *:last-child {\n    margin-bottom: 0; /* Last:mb-0 */\n  }\n\n  /* Columns */\n  [data-type=\"columns\"] {\n    display: grid; /* Grid */\n    gap: 1rem; /* Gap-4 */\n    margin-top: 3.5rem; /* Mt-14 */\n    margin-bottom: 3rem; /* Mb-12 */\n  }\n\n  [data-type=\"columns\"].layout-sidebar-left {\n    grid-template-columns: 40fr 60fr;\n  }\n\n  [data-type=\"columns\"].layout-sidebar-right {\n    grid-template-columns: 60fr 40fr;\n  }\n\n  [data-type=\"columns\"].layout-two-column {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  [data-type=\"column\"] {\n    overflow: auto; /* Overflow-auto */\n  }\n\n  /* Details */\n  [data-type=\"details\"] {\n    display: flex; /* Flex */\n    gap: 0.25rem; /* Gap-1 */\n    margin-top: 1.5rem; /* My-6 */\n    margin-bottom: 1.5rem; /* My-6 */\n    margin-left: auto; /* Mx-auto */\n    margin-right: auto; /* Mx-auto */\n    padding: 0.5rem; /* P-2 */\n    border: 1px solid #d1d5db; /* Border-gray-300 */\n    border-radius: 0.25rem; /* Rounded */\n  }\n\n  [data-type=\"details\"] summary {\n    font-weight: bold; /* Font-bold */\n    display: block; /* Block */\n  }\n\n  [data-type=\"details\"] > button {\n    background-color: transparent; /* Bg-transparent */\n    border: none; /* Border-none */\n    cursor: pointer; /* Cursor-pointer */\n    display: flex; /* Flex */\n    align-items: center; /* Items-center */\n    justify-content: center; /* Justify-center */\n    border-radius: 0.25rem; /* Rounded */\n    font-size: 0.75rem; /* Text-xs */\n    height: 1.25rem; /* H-5 */\n    width: 1.25rem; /* W-5 */\n  }\n\n  [data-type=\"details\"] > button:hover {\n    background-color: #d1d5db; /* Bg-gray-300 */\n  }\n\n  [data-type=\"details\"].dark > button:hover {\n    background-color: #1f2937; /* Dark:bg-gray-800 */\n  }\n\n  [data-type=\"details\"] > button::before {\n    content: \"\\25B6\"; /* Triangle icon */\n  }\n\n  [data-type=\"details\"].is-open > button::before {\n    transform: rotate(90deg); /* Rotate-90 */\n  }\n\n  [data-type=\"details\"] > div {\n    display: flex; /* Flex */\n    flex-direction: column; /* Flex-col */\n    gap: 1rem; /* Gap-4 */\n    width: 100%; /* W-full */\n  }\n\n  [data-type=\"details\"] > div > [data-type=\"detailsContent\"] > :last-child {\n    margin-bottom: 0.5rem; /* Mb-2 */\n  }\n\n  [data-type=\"details\"] [data-type=\"details\"] {\n    margin-top: 0.5rem; /* My-2 */\n    margin-bottom: 0.5rem; /* My-2 */\n    margin-left: 0; /* Mx-0 */\n    margin-right: 0; /* Mx-0 */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
